export default {
  account: null,
  accountData: null,
  accounts: [],
  authorityAccounts: [],
  products: {}
}
